import UserService from "@/services/api/UserService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchUserInfo = createAsyncThunk(
  "user/fetchUserInfo",
  async () => {
    const data = await UserService.getProfile();
    return data;
  }
);

export const updateUserInfo = createAsyncThunk(
  "user/updateUserInfo",
  async (formData) => {
    console.log("formData", formData);
    const data = await UserService.updateProfile(formData);
    return data;
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    userInfo: null,
    status: "idle",
    error: null,
  },
  reducers: {
    setUser(state, action) {
      state.userInfo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserInfo.fulfilled, (state, action) => {
        state.userInfo = action.payload;
        state.status = "succeeded";
      })
      .addCase(updateUserInfo.fulfilled, (state, action) => {
        state.userInfo = action.payload;
        state.status = "updated";
      })
      .addCase(fetchUserInfo.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;